import { render, staticRenderFns } from "./SwitchPopup.vue?vue&type=template&id=7f60c02c&scoped=true&"
import script from "./SwitchPopup.vue?vue&type=script&lang=js&"
export * from "./SwitchPopup.vue?vue&type=script&lang=js&"
import style0 from "./SwitchPopup.vue?vue&type=style&index=0&id=7f60c02c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f60c02c",
  null
  
)

export default component.exports